module.exports = __webpack_public_path__ + "img/school_qzyc2.36b14377.png";